<template>
  <div class="resume-module-manager">
    <div class="module-title">
      <div class="m-l">
        <img class="icon" src="../../assets/img/bookmark-one.png" alt="">
        <div class="title">教育经历</div>
      </div>
      <div class="m-r">
        <img @click="handleAdd" class="add-icon" src="../../assets/img/Add.png" alt="">
      </div>
    </div>
    <div class="data-wrap" v-if="dataList.length && !detailShow">
      <div class="wrap-item data-item-wrap" v-for="item in dataList" :key="item.id">
        <div class="action">
          <img @click="handleEdit(item)" class="edit-icon" src="../../assets/img/edit.png" alt="">
          <img @click="handleDelete(item.id)" class="delete-icon" src="../../assets/img/delete.png" alt="">
        </div>
        <div class="school-wrap">
          <div class="school-info">
            <div class="school-name">{{ item.school }}</div>
            <div class="school-period">
              <div class="start-date">{{ formatDate(item.start_date) }}</div>-
              <div class="end-date">{{ formatDate(item.end_date) }}</div>
            </div>
          </div>

          <div class="school-attr-list">
            <div class="school-attr-item">{{ item.major }}</div>
            <div class="school-attr-line"></div>
            <div class="school-attr-item">{{ item.degree }}</div>
            <div class="school-attr-item school-gpa">GPA：{{ item.gpa }}</div>
          </div>

          <div class="school-courses">主修课程：{{ item.courses }}</div>
        </div>
      </div>
    </div>
    <div class="data-form-wrap" v-if="detailShow">
      <div class="title">{{ form.id ? '编辑教育经历' : '添加教育经历' }}</div>
      <el-form :model="form" ref="formRef" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学校" prop="school">
              <el-input clearable class="w100" v-model="form.school" placeholder="请填写学校"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学历" prop="degree">
              <el-select clearable class="w100" v-model="form.degree" placeholder="请选择学历">
                <el-option v-for="item in education" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专业" prop="major">
              <el-input clearable class="w100" v-model="form.major" placeholder="请填写专业"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="start_date">
              <div class="date-picker-wrap">
                <el-date-picker value-format="yyyy-MM-dd" clearable prefix-icon="''" style="width: 45%;"
                  v-model="form.start_date" type="month" placeholder="开始时间"></el-date-picker>
                -
                <el-date-picker value-format="yyyy-MM-dd" clearable prefix-icon="''" style="width: 45%;"
                  v-model="form.end_date" type="month" placeholder="结束时间"></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="GPA" prop="gpa">
              <el-input clearable class="w100" v-model="form.gpa" placeholder="请填写GPA"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成绩排名" prop="rank">
              <el-select clearable class="w100" v-model="form.rank" placeholder="请选择成绩排名">
                <el-option v-for="item in rank_list" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="主修课程" prop="courses">
              <el-input clearable class="w100" type="textarea" :rows="5" v-model="form.courses" placeholder="请填写主修课程"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer">
        <el-button size="small" class="cancel-btn" @click="handleCancel">取消</el-button>
        <el-button size="small" class="save-btn" type="primary" @click="handleSave">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Education',
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      education: ['未知', '初中', '高中', '大专', '本科', '硕士', '博士'],
      rank_list: [
        { label: '前10%', value: '前10%' },
        { label: '前30%', value: '前30%' },
        { label: '中等', value: '中等' },
        { label: '中下', value: '中下' }
      ],
      detailShow: false,
      form: {
        id: '',
        school: '',
        degree: '',
        major: '',
        start_date: '',
        end_date: '',
        gpa: '',
        courses: '',
        rank: '',
      },
      rules: {
        school: [{ required: true, message: '请填写学校', trigger: 'blur' }],
        degree: [{ required: true, message: '请选择学历', trigger: 'change' }],
        start_date: [
          { required: true, message: '请选择开始时间', trigger: 'change' },
          { validator: this.validateDate, trigger: 'change' }
        ],
        major: [{ required: true, message: '请填写专业', trigger: 'blur' }],
      }
    }
  },
  methods: {
    validateDate(rule, value, callback) {
      if (!this.form.end_date) {
        callback(new Error('请选择结束时间'));
        return;
      }
      if (this.form.start_date && this.form.end_date && this.form.start_date > this.form.end_date) {
        callback(new Error('开始时间不能大于结束时间'));
      } else {
        callback();
      }
    },
    formatDate(date) {
      if (!date) return '--'
      // 只返回年月日部分
      return date.split(' ')[0] || date
    },
    handleAdd() {
      this.detailShow = true;
      this.form = {
        id: '',
        school: '',
        degree: '',
        major: '',
        start_date: '',
        end_date: '',
        gpa: '',
        courses: '',
        rank: '',
      }
    },
    handleEdit(item) {
      this.detailShow = true;
      this.form = item;
    },
    handleDelete(id) {
      this.$confirm('确定删除该教育经历吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('delete', id);
      });
    },
    handleCancel() {
      this.$confirm('确定取消编辑吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detailShow = false;
        this.$refs.formRef.resetFields();
      });
    },
    handleSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const formatDate = (dateStr) => {
            const date = new Date(dateStr)
            if (isNaN(date.getTime())) return dateStr
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day} 00:00:00.000`
          }
          this.$emit('save', {
            ...this.form,
            start_date: formatDate(this.form.start_date),
            end_date: formatDate(this.form.end_date)
          });
          this.detailShow = false;
          this.$refs.formRef.resetFields();
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.w100 {
  width: 100% !important;
}

.resume-module-manager {
  padding: 18px 0 18px 12px;
  border-bottom: 1px dashed #B16EF9;

  .module-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .m-l {
      display: flex;
      align-items: center;

      .icon {
        width: 26px;
        height: 26px;
        margin-right: 12px;
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        color: #656587;
      }
    }

    .m-r {
      cursor: pointer;
      display: flex;
      width: 24px;
      height: 24px;

      .add-icon {
        width: 100%;
        height: 100%;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .data-wrap {
    margin-top: 16px;

    .wrap-item {
      cursor: pointer;
      padding-left: 36px;
      padding-top: 8px;
      padding-bottom: 8px;
      border-radius: 12px;

      &:hover {
        background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;
      }

      .action {
        display: flex;
        justify-content: flex-end;
        padding-right: 5px;

        .delete-icon,
        .edit-icon {
          cursor: pointer;
          width: 16px;

          &:hover {
            opacity: .8;
          }
        }

        .edit-icon {
          margin-right: 8px;
        }
      }

      .school-wrap {
        .school-info {
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          .school-name {
            min-width: 200px;
            font-size: 20px;
            font-weight: 600;
            color: #000000;
            margin-bottom: 8px;
          }

          .school-period {
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #656587;
            margin-bottom: 8px;
          }
        }

        .school-attr-list {
          display: flex;
          align-items: center;

          .school-attr-item {
            font-size: 14px;
            color: #656587;
            line-height: 24px;

            &.school-gpa {
              margin-left: 36px;
            }
          }

          .school-attr-line {
            width: 1px;
            margin: 0 12px;
            height: 16px;
            background-color: #656587;
          }
        }

        .school-courses {
          margin-top: 8px;
          font-size: 14px;
          color: #656587;
          line-height: 20px;
        }
      }
    }
  }

  .data-form-wrap {
    margin-top: 16px;
    padding: 16px 16px 16px 36px;
    border-radius: 12px;
    // background: #fcfcfc;
    background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;

    .title {
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 600;
      color: #656587;
    }

    .date-picker-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .footer {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>